import { render } from "./ModalFooter.vue?vue&type=template&id=2e1e56d2&scoped=true&ts=true"
import script from "./ModalFooter.vue?vue&type=script&lang=ts"
export * from "./ModalFooter.vue?vue&type=script&lang=ts"

import "./ModalFooter.vue?vue&type=style&index=0&id=2e1e56d2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1e56d2"]])

export default __exports__